module.exports = __webpack_public_path__ + "img/Youtube_footer.9822e40d.svg";